import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../services/filtering/filter-form-render-service/';
import { messages } from './messages';

export const ReturnsLabel = {
  id: 'returnsLabel',
  displayName: <FormattedMessage {...messages.label} />,
  type: OptionFormTypes.TYPE_IS_OPTIONS,
  filterValue: 'isLabelPrinted',

  render: (criteriaInformations) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_IS_OPTIONS, criteriaInformations);
  },
};
